import { BehaviorStudent } from './behavior-student.model';
import { BehaviorIncident } from './behavior-incident.model';
import { BehaviorAttachment } from './behavior-attachment.model';
import { BehaviorAction } from './behavior-action.model';
import { BehaviorFunctional } from './behavior-functional.model';

export class BehaviorEvent {
    Id = -1;
    EventNumber = '';
    StaffName = '';
    EventName = '';
    Description = '';
    AYIdentifier = '';
    Date: Date | string = null;   // DTO returns a string which can sometimes contain an offset
    // Allowing string type allows the offset to be removed without causing additional timezone issues by converting to Date object
    SentOn: Date = null;
    StaffComment = '';
    AdminComment = '';
    AddedBy: number;
    AddedByName: string;
    AddedOn: Date = null;
    ViewedByAdmin: number;
    ViewedByAdminOn: Date = null;
    Location = '';
    Publish: boolean;
    ClosedEvent: boolean;
    Context = '';
    SiteId: number;
    Reported: boolean;
    ReportedBy: number;
    CaseNumber = '';
    ActionsNotReq: boolean;
    LastUpBy: number;
    LastUpByName: string;
    LastUpOn: Date = null;
    OutOfDistrictSchool = '';
    Suspended: boolean;
    Students: BehaviorStudent[] = [];
    SchoolId = -1;
    Deleted: boolean;
    Incidents: BehaviorIncident[] = [];
    Actions: BehaviorAction[] = [];
    Attachments: BehaviorAttachment[] = [];
    DefaultIncidentCodeId: string;
    DefaultAlcoholRelated: boolean;
    DefaultGangRelated: boolean;
    DefaultDrugRelated: boolean;
    DefaultHateRelated: boolean;
    DefaultWeaponRelated: boolean;
    DefaultReportedToPolice: boolean;
    ReferralId: number;
    IncidentTime: string;
    RoomNumber: string;
    IncidentsFunctionalCodeId: number;
    DisciplineIncidentSubCodeId: number;
    Functional: BehaviorFunctional[] = [];
    LocationId = '';
    OffenderType: string;
    // not part of DTO
    readOnly = false;
    // v9
    IncidentId: number;
    CodeDesc = '';
    StateCode = '';
    SiteName: string;
    EnteredBy: number;
    AdminVerified: boolean;
    ViolenceRelated: boolean;
    CriminalOffense: boolean;
    IncidentWeaponCodeId: number;
    IncidentDrugCodeId: number;
    IncidentTimeCodeId: number;
    ActionCodeDesc: string;
    SarvedType: number;
    checked = false;
}
